<template>
    <div>
        <le-search-form @reset="handlerRest" @search="handlerSearch" >
            <le-input label="订单编号" v-model="pageParam.params.orderId" placeholder="请输入订单编号" />
            <le-input label="设备编号" v-model="pageParam.params.deviceCode" placeholder="请输入订单编号" />
            <le-select-remote-search label="站点" v-model="pageParam.params.stationId" :options="optionsStation" placeholder="请选择（可输入搜索）" />
            <le-company-under-select label="商户" v-model="pageParam.params.companyId"></le-company-under-select>
            <le-date-range 
                label="订单开始时间" 
                :minDate.sync="pageParam.params.startTime" 
                :maxDate.sync="pageParam.params.endTime" 
                valueFormat="yyyy-MM-dd HH:mm:ss" 
                :defaultTime="['00:00:00','23:59:59']" />
        </le-search-form>
        <le-pagview ref="redpackageUse" @setData="setTableData" :pageParam="pageParam" v-if="pageParam">
            <el-table :data="tabledata">
                <el-table-column label="订单编号" prop="typeText">
                    <template slot-scope="{ row }">
                        <span class="a-c-blue font-point" @click="handleToOrderInfo(row)">{{ row.orderId || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备编号" prop="content">
                    <template slot-scope="{ row }">
                        <span>{{ row.deviceCode || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="站点" prop="orderId">
                    <template slot-scope="{ row }">
                        <span>{{ row.stationName || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="商户" prop="activePower">
                    <template slot-scope="{ row }">
                        <span>{{ row.companyName || '-' }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="订单金额" prop="operatorUserPhone">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.changeAmount) }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="红包消耗" prop="cardNo">
                    <!-- <template slot="header" slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="该次充电订单消耗的余额金额" placement="top">
                            <span>红包消耗</span>
                            <span class="el-icon-question"></span>
                        </el-tooltip>
                    </template> -->
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.changeAmount) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="消耗后剩余" prop="cardNo">
                    <!-- <template slot="header" slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="该次充电退款时退还的红包余额" placement="top">
                            <span>消耗后剩余</span>
                            <span class="el-icon-question"></span>
                        </el-tooltip>
                    </template> -->
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.afterAmount) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单状态" prop="createTimeText">
                    <template slot-scope="{ row }">
                        <span>{{ row.orderStatusStr || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单开始时间" prop="createTimeText">
                    <template slot-scope="{ row }">
                        <span>{{ row.startTime || '-' }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </le-pagview>
    </div>
</template>

<script>
    import util from '@/utils/util.js'
    export default {
        data() {
            return {
                util: util,
                pageParam: {
                    url: this.$Config.apiUrl.userRedPackUseRecordVoPage,
                    method: "post",
                    params: {
                        "companyId": "",
                        "deviceCode": "",
                        "endTime": "",
                        "orderId": "",
                        "startTime": "",
                        "stationId": "",
                        "userId": this.userId
                    },
                    freshCtrl: 1,
                },
                optionsStation: {
                    url: this.$Config.apiUrl.getStationList,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "stationId",
                    searchKey: "name",
                    pageSize: 100
                },//站点数据
                tabledata: [],
            }
        },
        props:['userId','phone'],
        mounted () {

        },
        methods:{
            handlerRest() {
                this.pageParam.params = {
                    "companyId": "",
                    "deviceCode": "",
                    "endTime": "",
                    "orderId": "",
                    "startTime": "",
                    "stationId": "",
                    "userId": this.userId
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs.redpackageUse.pageNum = 1
                this.pageParam.freshCtrl++;
            },
            setTableData (datas) {
                this.tabledata = datas.map(item=>{
                    return {
                        ...item,
                    }
                })
            },
            handleToOrderInfo (datas) {
                switch (datas.orderType){
					case 1:
						// 套餐订单
                        if (!this.$_has(72)) return this.$message.warning('暂无权限')
						this.$router.push({
                            path:'/order/package-order-info',
                            query: {
                                id: datas.orderId
                            }
                        })
						break;
					case 2:
						// 充电订单
                        if (!this.$_has(4)) return this.$message.warning('暂无权限')
						this.$router.push({
                            path: '/order/order-detail',
                            query: {
                                'orderId': datas.orderId
                            }
                        })
						break;
					case 4:
					case 5:
						// 充电柜订单
                        if (!this.$_has(101)) return this.$message.warning('暂无权限')
						this.$router.push({
                            path:'/order/chargeCabinet-order-info',
                            query: {
                                orderId: datas.orderId,
                                orderSn: datas.orderId
                            }
                        })
						break;
					default:
						break;
				}
            }
        }
    }
</script>

<style lang="scss" scoped>
   
</style>